import { Reservation } from '../types/Reservation'
import { SReservation } from '../types/api/Reservation'

import { offerTransformer } from './offerTransformer'
import { userTransformer } from './userTransformer'

export const reservationTransformer = (data: SReservation): Reservation => {
  return {
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    email: data.email,
    id: data.documentId ?? (data.id != null ? String(data.id) : ''),
    user: data.user ? userTransformer(data.user) : undefined,
    offer: data.offer ? offerTransformer(data.offer) : undefined,
  } as Reservation
}
